import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services/base-http-req-resp.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { CommonService } from '../../question/services/commonservice';
import { Company, MasterCompanyDetail } from '../models/company.model';

@Injectable()
export class CompanyService extends BaseHttpReqRespService {
  myAppUrl: any;
  COMPANY_ENDPOINT = API_ENDPOINTS.COMPANY;

  constructor(
    http: HttpClient,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private EncrDecr: EncrDecrService,
    private commonService: CommonService,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }

  // ── GET: Company list ──────────────────────────────────────
  getCompanyList(workspaceId: string): Observable<Company[]> {
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.COMPANY_ENDPOINT.LIST}?workspaceId=${workspaceId}`
    );
  }

  // ── GET: New company (blank form init) ─────────────────────
  getNewCompany(): Observable<Company> {
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.COMPANY_ENDPOINT.NEW}`
    );
  }

  // ── GET: Edit company by ID ────────────────────────────────
  editCompany(companyId: number, userId: string): Observable<Company> {
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.COMPANY_ENDPOINT.EDIT}?companyId=${companyId}&userId=${userId}`
    );
  }

  // ── POST: Save company (create or update) ──────────────────
  saveCompany(model: Partial<Company>): Observable<Company[]> {
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');
    const workSpaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    return this.http.post<Company[]>(
      `${this.myAppUrl}/${this.COMPANY_ENDPOINT.SAVE}`,
      model,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        params: { userId, workSpaceId }
      }
    );
  }

  // ── POST: Delete company ───────────────────────────────────
  deleteCompany(companyId: number): Observable<void> {
    const workSpaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');
    const url = `${this.myAppUrl}/${this.COMPANY_ENDPOINT.DELETE}`
      + `?companyId=${companyId}&workSpaceId=${workSpaceId}&userId=${userId}`;
    return this.http.post<void>(url, null, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    });
  }

  // ── POST: Master company list (for export) ─────────────────
  getMasterCompanyList(workspaceId: string): Observable<MasterCompanyDetail[]> {
    return this.http.post<MasterCompanyDetail[]>(
      `${this.myAppUrl}/${this.COMPANY_ENDPOINT.MASTER_LIST}?workSpaceId=${workspaceId}`,
      null,
      { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    );
  }
}
